import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d988de2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["transform"]
const _hoisted_4 = ["d", "fill", "stroke", "stroke-width", "stroke-dasharray"]

import { computed, nextTick, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTShapeElement, ShapeText } from '@/types/slides'
import type { ContextmenuItem } from '@/components/Contextmenu/types'
import useElementOutline from '@/views/components/element/hooks/useElementOutline'
import useElementShadow from '@/views/components/element/hooks/useElementShadow'
import useElementFlip from '@/views/components/element/hooks/useElementFlip'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import GradientDefs from './GradientDefs.vue'
import ProsemirrorEditor from '@/views/components/element/ProsemirrorEditor.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    elementInfo: {},
    selectElement: { type: Function },
    contextmenus: { type: Function }
  },
  setup(__props: any) {

const props = __props

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { handleElementId, shapeFormatPainter } = storeToRefs(mainStore)

const { addHistorySnapshot } = useHistorySnapshot()

const handleSelectElement = (e: MouseEvent | TouchEvent, canMove = true) => {
  if (props.elementInfo.lock) return
  e.stopPropagation()

  props.selectElement(e, props.elementInfo, canMove)
}

const execFormatPainter = () => {
  if (!shapeFormatPainter.value) return
  const { keep, ...newProps } = shapeFormatPainter.value

  slidesStore.updateElement({
    id: props.elementInfo.id, 
    props: newProps,
  })
  
  addHistorySnapshot()
  if (!keep) mainStore.setShapeFormatPainter(null)
}

const outline = computed(() => props.elementInfo.outline)
const { outlineWidth, outlineColor, strokeDashArray } = useElementOutline(outline)

const shadow = computed(() => props.elementInfo.shadow)
const { shadowStyle } = useElementShadow(shadow)

const flipH = computed(() => props.elementInfo.flipH)
const flipV = computed(() => props.elementInfo.flipV)
const { flipStyle } = useElementFlip(flipH, flipV)

const editable = ref(false)

watch(handleElementId, () => {
  if (handleElementId.value !== props.elementInfo.id) {
    if (editable.value) editable.value = false
  }
})

const text = computed<ShapeText>(() => {
  const defaultText: ShapeText = {
    content: '',
    defaultFontName: '微软雅黑',
    defaultColor: '#000',
    align: 'middle',
  }
  if (!props.elementInfo.text) return defaultText

  return props.elementInfo.text
})

const updateText = (content: string) => {
  const _text = { ...text.value, content }
  slidesStore.updateElement({
    id: props.elementInfo.id, 
    props: { text: _text },
  })
  
  addHistorySnapshot()
}

const checkEmptyText = () => {
  if (!props.elementInfo.text) return

  const pureText = props.elementInfo.text.content.replaceAll(/<[^>]+>/g, '')
  if (!pureText) {
    slidesStore.removeElementProps({ id: props.elementInfo.id, propName: 'text' })
    addHistorySnapshot()
  }
}

const prosemirrorEditorRef = ref<InstanceType<typeof ProsemirrorEditor>>()
const startEdit = () => {
  editable.value = true
  nextTick(() => prosemirrorEditorRef.value && prosemirrorEditorRef.value.focus())
}

return (_ctx: any,_cache: any) => {
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-element-shape", {
      'lock': _ctx.elementInfo.lock,
      'format-painter': _unref(shapeFormatPainter),
    }]),
    style: _normalizeStyle({
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${_ctx.elementInfo.rotate}deg)` })
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "element-content",
        style: _normalizeStyle({
          opacity: _ctx.elementInfo.opacity,
          filter: _unref(shadowStyle) ? `drop-shadow(${_unref(shadowStyle)})` : '',
          transform: _unref(flipStyle),
          color: text.value.defaultColor,
          fontFamily: text.value.defaultFontName,
        }),
        onMousedown: _cache[3] || (_cache[3] = $event => handleSelectElement($event)),
        onMouseup: _cache[4] || (_cache[4] = ($event: any) => (execFormatPainter())),
        onTouchstart: _cache[5] || (_cache[5] = $event => handleSelectElement($event)),
        onDblclick: _cache[6] || (_cache[6] = ($event: any) => (startEdit()))
      }, [
        (_openBlock(), _createElementBlock("svg", {
          overflow: "visible",
          width: _ctx.elementInfo.width,
          height: _ctx.elementInfo.height
        }, [
          (_ctx.elementInfo.gradient)
            ? (_openBlock(), _createElementBlock("defs", _hoisted_2, [
                _createVNode(GradientDefs, {
                  id: `editabel-gradient-${_ctx.elementInfo.id}`,
                  type: _ctx.elementInfo.gradient.type,
                  color1: _ctx.elementInfo.gradient.color[0],
                  color2: _ctx.elementInfo.gradient.color[1],
                  rotate: _ctx.elementInfo.gradient.rotate
                }, null, 8, ["id", "type", "color1", "color2", "rotate"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("g", {
            transform: `scale(${_ctx.elementInfo.width / _ctx.elementInfo.viewBox[0]}, ${_ctx.elementInfo.height / _ctx.elementInfo.viewBox[1]}) translate(0,0) matrix(1,0,0,1,0,0)`
          }, [
            _createElementVNode("path", {
              class: "shape-path",
              "vector-effect": "non-scaling-stroke",
              "stroke-linecap": "butt",
              "stroke-miterlimit": "8",
              d: _ctx.elementInfo.path,
              fill: _ctx.elementInfo.gradient ? `url(#editabel-gradient-${_ctx.elementInfo.id})` : _ctx.elementInfo.fill,
              stroke: _unref(outlineColor),
              "stroke-width": _unref(outlineWidth),
              "stroke-dasharray": _unref(strokeDashArray)
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3)
        ], 8, _hoisted_1)),
        _createElementVNode("div", {
          class: _normalizeClass(["shape-text", [text.value.align, { 'editable': editable.value || text.value.content }]])
        }, [
          (editable.value || text.value.content)
            ? (_openBlock(), _createBlock(ProsemirrorEditor, {
                key: 0,
                ref_key: "prosemirrorEditorRef",
                ref: prosemirrorEditorRef,
                elementId: _ctx.elementInfo.id,
                defaultColor: text.value.defaultColor,
                defaultFontName: text.value.defaultFontName,
                editable: !_ctx.elementInfo.lock,
                value: text.value.content,
                onUpdate: _cache[0] || (_cache[0] = value => updateText(value)),
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (checkEmptyText())),
                onMousedown: _cache[2] || (_cache[2] = $event => handleSelectElement($event, false))
              }, null, 8, ["elementId", "defaultColor", "defaultFontName", "editable", "value"]))
            : _createCommentVNode("", true)
        ], 2)
      ], 36)), [
        [_directive_contextmenu, _ctx.contextmenus]
      ])
    ], 4)
  ], 6))
}
}

})